import React from 'react';
import styles from '../../../styles/EducationHub.module.css';

interface ContentMediaProps {
  content: any; // Guide | NewsPost | UpdateNote (but only Guide has mediaUrls)
}

const ContentMedia: React.FC<ContentMediaProps> = ({ content }) => {
  if (!content) return null;

  // Only look for video URLs
  const hasMedia = 'mediaUrls' in content && Array.isArray(content.mediaUrls);

  if (!hasMedia) {
    // No video media, just render the content as before
    return (
      <div 
        className={styles.htmlContent}
        dangerouslySetInnerHTML={{ __html: content.content }}
      />
    );
  }
  // Only render video files as media
  const mediaUrls = (content as any).mediaUrls as string[];

  return (
    <>
      <div 
        className={styles.htmlContent}
        dangerouslySetInnerHTML={{ __html: content.content }}
      />
      {mediaUrls.length > 0 && (
          <div className={styles.mediaGroup}>
            <h4>Media:</h4>
            {mediaUrls.map((url, index) => (
                <div key={`inline-video-${index}`} className={styles.inlineMedia}>
                <video controls className={styles.inlineVideo}>
                    <source src={url} />
                    Your browser does not support the video tag.
                </video>
                </div>
            ))}
        </div>
      )}
    </>
  );
};

export default ContentMedia;
